import gql from 'graphql-tag';

export const refreshMembersQuery = gql`
  query refreshMembers {
    me {
      organization {
        id
        members {
          id
          email
          name
          avatarUrl
          isAdmin
        }
      }
    }
  }
`;
